import PropTypes from 'prop-types'
import React from 'react'

import { withI18n } from '@thebeansgroup/i18n'

import Layout from '@components/layout'
import ThemedButton from '@components/themed_button'

export class AccountNotRecognisedScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  renderSignUpButton() {
    const { t, signUpClickHandler } = this.props
    return (
      <ThemedButton onClick={signUpClickHandler}>{t('a_sign_up')}</ThemedButton>
    )
  }

  renderBackToLoginButton() {
    const { t, backToLoginClickHandler } = this.props
    return (
      <ThemedButton
        onClick={backToLoginClickHandler}
        type='secondary'
      >
        {t('a_back_to_log_in')}
      </ThemedButton>
    )
  }

  render() {
    const { t, account } = this.props
    return (
      <Layout
        title={t('d_account_not_recognised')}
        description={t('m_account_not_recognised', { account })}
      >
        {this.renderSignUpButton()}
        {this.renderBackToLoginButton()}
      </Layout>
    )
  }
}

AccountNotRecognisedScreen.propTypes = {
  t: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  backToLoginClickHandler: PropTypes.func.isRequired,
  signUpClickHandler: PropTypes.func.isRequired
}

export default withI18n(AccountNotRecognisedScreen)
